// extracted by mini-css-extract-plugin
export default {"image":"HeroImage_image__KbnF7"};